<template>
  <div>
    <div class="card">
      <div class="card-header">
        Timesheet
        <span class="pull-right">{{ $store.state.timesheet.items.length }} / {{ $store.state.timesheet.total }} items</span>
      </div>
      <div class="card-body">
        <b-row>
          <b-col v-if="canAddTimesheet" md="auto" class="pr-1">
            <b-button variant="primary" @click="openModal()">
              <i class="fa fa-plus"></i> Adicionar
            </b-button>
          </b-col>
          <b-col class="pl-1">
            <b-form-input v-model="search" placeholder="Busca..." class="mb-2" debounce="500"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <div class="mb-3">
              <div class="">
                <div class="">
                  <div class="card" style="margin-bottom:0">
                    <div class="card-body p-0 d-flex align-items-center">
                      <i class="fa fa-clock-o bg-primary p-4 font-2xl mr-3"></i>
                      <div>
                        <div class="text-value-sm text-primary">{{ TimeSheetTotalHours.totalHours }}</div>
                        <div class="text-muted text-uppercase font-weight-bold small">Horas</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="card">
                <div class="card-header">Selecione um filtro</div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-12">
                      <b-form-group label="Cliente">
                        <v-select v-model="filters.customer_pk" :reduce="item => item.pk" label="social_name" placeholder="---------------------" :options="customers" />
                      </b-form-group>
                    </div>
                    <div class="col-12">
                      <b-form-group label="Contrato">
                        <v-select v-model="filters.contract_pk" :reduce="item => item.pk" label="name" placeholder="---------------------" :options="filtertimesheet" />
                      </b-form-group>
                    </div>
                    <div class="col-12" v-if="!isSimpleUser">
                      <b-form-group label="Funcionário">
                        <v-select v-model="filters.employee_pk" :reduce="item => item.pk" label="name" placeholder="---------------------" :options="this.$store.state.employees.active" />
                      </b-form-group>
                    </div>
                    <!-- <div class="col-12">
                  <b-form-group label="Tipo de contrato">
                    <b-form-select v-model="filters.payment_type" :options="payment_types"></b-form-select>
                  </b-form-group>
                </div> -->
                    <!-- <div class="col-12">
                  <b-form-group label="Área">
                    <v-select
                      v-model="filters.area_pk"
                      :reduce="item => item.pk"
                      label="text"
                      placeholder="---------------------"
                      :options="areas"
                    />
                  </b-form-group>
                </div> -->
                    <div class="col-12">
                      <b-form-group label="Mês">
                        <b-form-select v-model="filters.month" :options="months"></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col-12">
                      <b-form-group label="Ano">
                        <b-form-select v-model="filters.year">
                          <option :value='null'>Todos</option>
                          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col-12">
                      <b-form-group label="Conferido">
                        <b-form-select v-model="filters.conferred">
                          <option :value='null'>Todos</option>
                          <option :value='true'>Sim</option>
                          <option :value='false'>Não</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col-12">
                      <b-form-group label="Tem Relatório">
                        <b-form-select v-model="filters.contains_ts_report">
                          <option :value='null'>Todos</option>
                          <option :value='true'>Sim</option>
                          <option :value='false'>Não</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <b-button variant="danger" @click="cleanFilter">Limpar</b-button>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <b-col cols="9" class="pl-1">
            <div>
              <b-table striped :items="$store.state.timesheet.items" :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" no-local-sorting>
                <template v-slot:cell(timesheet_date)="data">
                  {{ data.item.timesheet_date | formatDate }}
                  <div>
                    <b-progress class="progress-xs" variant="success" :value="getMinutes(data.item.timesheet_hours) / totalMinutes * 100" height="{}" />
                    <span class="lead">{{ data.item.timesheet_hours }}</span>
                  </div>
                  <!-- Verifica se tem Relatório ou não -->
                  <span class="pull-right text-muted" v-if="$store.getters['auth/isAdmin']">
                    <small v-if="data.item.contains_ts_report.status">
                      <a :href="`/timesheet/report/detail/${data.item.contains_ts_report.pk}/`" target="_blank">Relat. {{ data.item.contains_ts_report.code }}</a>
                    </small>
                    <small v-else>Relat. </small>
                    <i v-if="data.item.contains_ts_report.status" class="fa fa-check ok"></i>
                    <i v-else class="fa fa-exclamation no"></i>
                  </span>
                </template>
                <template v-slot:cell(contract.title)="data">
                  <span>{{ data.item.customer.social_name }}</span>
                  <br>
                  <router-link v-if="$store.getters['auth/isAdmin']" :to="'/contracts/' + data.item.contract.pk"><small>{{ data.item.contract.title }}</small></router-link>
                </template>
                <template v-slot:cell(conferred_by.full_name)="data">
                  <div>
                    <input
                      style="display: block;"
                      type="checkbox"
                      class="checkbox-circular"
                      v-if="$store.getters['auth/isAdmin']"
                      size="lg"
                      :checked="isChecked(data.item)"
                      @change="toggleConferred(data.item)"
                    >
                    <div>
                      <small class="text-muted">{{ data.item.conferred_by.full_name }}</small>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(actions)="data">
                  <div class="pull-right">
                    <span class="span-is-link span-color-link float-right">
                      <i
                        v-if="canEditTimesheet && !data.item.conferred"
                        class="fa fa-pencil-square-o"
                        @click="editItem(data.item)"
                        title="Editar"
                      ></i>
                      <i
                        v-if="canDeleteTimesheet && !data.item.conferred"
                        class="fa fa-trash trash-color ml-3"
                        @click="deleteItem(data.item)"
                        title="Apagar"
                      ></i>
                    </span>
                  </div>
                </template>
              </b-table>
              <div style="text-align: right;">
                <b-pagination :total-rows="$store.state.timesheet.total" :per-page="$store.state.timesheet.perPage" v-model="currentPage" style="display: inline-flex;"></b-pagination>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-modal :visible="isVisible" :title="editingItem.pk ? 'Editar' : 'Adicionar'" @ok.prevent="passes(sendItem)" @hidden="clearModal" cancel-title="Cancelar" ok-title="Salvar">
        <generic-form :fields="fields" :editing="editingItem"></generic-form>
      </b-modal>
    </ValidationObserver>
  </div>
</template>
<script>
import axios from 'axios';
import GenericForm from '../../components/GenericForm';
import { Switch as cSwitch } from '@coreui/vue';
import vSelect from 'vue-select';
import Vue from 'vue';

export default {
  components: {
    GenericForm,
    cSwitch,
    vSelect,
  },
  data() {
    return {
      sortBy: 'timesheet_date',
      sortDesc: false,
      defaultEditing: {
        username: '',
      },
      tableFields: [{
          key: 'timesheet_date',
          label: 'Data',
          sortable: true,
        },
        {
          key: 'contract.title',
          label: 'Cliente/Contrato',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Descrição'
        },
        {
          key: 'employee.full_name',
          label: 'Funcionário'
        },
        {
          key: 'conferred_by.full_name',
          label: 'Conferido'
        },
        {
          key: 'actions',
          label: 'Ações'
        },
      ],
      editingItem: {
        description: '',
        timesheet_hours: 0,
        timesheet_minutes: '00',
        area_pk: null,
      },
      isVisible: false,
      searchFields: ['description'],
      search: '',
      today: null,

      filters: {},
      filtertimesheet: [],

      customers: [],
      contracts: [],
      areas: [],
      lastFilterLoadedtimesheet: 0,

      startToggler: false,

      payment_types: [
        { value: null, text: 'Todos' },
        { value: 'v', text: 'a vista' },
        { value: 'p', text: 'parcelado' },
        { value: 'm', text: 'mensal' },
      ],
      months: [
        { 'value': '', 'text': 'Todos' },
        { 'value': '1', 'text': 'Janeiro' },
        { 'value': '2', 'text': 'Fevereiro' },
        { 'value': '3', 'text': 'Março' },
        { 'value': '4', 'text': 'Abril' },
        { 'value': '5', 'text': 'Maio' },
        { 'value': '6', 'text': 'Junho' },
        { 'value': '7', 'text': 'Julho' },
        { 'value': '8', 'text': 'Agosto' },
        { 'value': '9', 'text': 'Setembro' },
        { 'value': '10', 'text': 'Outubro' },
        { 'value': '11', 'text': 'Novembro' },
        { 'value': '12', 'text': 'Dezembro' }
      ],
      years: [],

      currentPage: 1,
    };
  },
  mounted() {
    this.startFilter();

    this.currentPage = 1;

    this.$store.dispatch('timesheet/loadItems', {
        ...this.filters,
        search: '',
        page: this.currentPage,
        order_by: this.sortBy,
        is_desc: this.sortDesc,
      })
      .then(() => {
        setTimeout(() => {
          this.startToggler = true;
        }, 500);
      });
    this.$store.dispatch('employees/loadActive');

    this.editingItem.timesheet_date = this.today;

    axios.get('/crm/customers/with-contract/')
      .then(response => {
        this.customers = response.data.data;
      });

    axios.get('/timesheet/areas/')
      .then(response => {
        this.areas = response.data.data;
      });

    axios.get('/timesheet/years/')
      .then(response => {
        this.years = response.data.years;
      })
  },
  computed: {
    isChecked() {
      return item => item.conferred;
    },
    isSimpleUser() {
      return this.$store.state.auth.user.groups.find(g => g.name == 'simpleuser');
    },
    canAddTimesheet() {
      return this.$store.state.auth.user.permission_codes.includes('add_timesheet');
    },
    canEditTimesheet() {
      return this.$store.state.auth.user.permission_codes.includes('change_timesheet');
    },
    canDeleteTimesheet() {
      return this.$store.state.auth.user.permission_codes.includes('delete_timesheet');
    },
    // totalHours() {
    //   return this.$store.state.timesheet.items.map(t => {
    //     const [hour, minutes] = t.timesheet_hours.split(':');

    //     return {
    //       hour,
    //       minutes,
    //     }
    //   }).reduce(function(memo, t) {
    //     memo[0] += parseInt(t.hour, 10)
    //     memo[1] += parseInt(t.minutes, 10)
    //     if (memo[1] >= 60) {
    //       memo[0] += ~~(memo[1] / 60)
    //       memo[1] = memo[1] % 60
    //     }
    //     return memo
    //   }, [0, 0]).map(function(t) {
    //     if (t < 10) {
    //       return '0' + t
    //     }
    //     return t
    //   }).join(':');
    // },
    TimeSheetTotalHours() {
      return this.$store.state.timesheet
    },
    totalMinutes() {
      if (!this.TimeSheetTotalHours) {
        return 1;
      }
      return 1;
      // return this.getMinutes(this.TimeSheetTotalHours);
    },
    fields() {
      const fields = [{
        text: 'Data de execução da atividade',
        name: 'timesheet_date',
        rules: 'required',
        type: 'datepicker',
      }, {
        text: 'Cliente',
        name: 'customer_pk',
        type: 'select2',
        selectOptions: this.customers,
        label: 'social_name',
        rules: 'required',
      }, {
        text: 'Contrato',
        name: 'contract_pk',
        type: 'select2',
        selectOptions: this.contracts,
        rules: 'required',
      }, {
        text: 'Área',
        name: 'area_pk',
        options: this.areas,
      }, {
        text: 'Descrição',
        name: 'description',
        rules: 'required',
        type: 'textarea',
      }];

      if (!this.isSimpleUser) {
        fields.push({
          text: 'Funcionário',
          name: 'employee_pk',
          type: 'select2',
          selectOptions: this.$store.state.employees.active,
          rules: 'required',
        });
      }

      fields.push(...[{
          text: 'Horas',
          name: 'timesheet_hours',
          type: 'positive_number',
          rules: 'required',
        },
        {
          text: 'Minutos',
          name: 'timesheet_minutes',
          type: 'radio_group',
          radioOptions: [
            { text: '0:00', value: '00' },
            { text: '0:15', value: '15' },
            { text: '0:30', value: '30' },
            { text: '0:45', value: '45' },
          ],
        }
      ]);

      if (this.$store.getters['auth/isAdmin']) {
        fields.push({
          text: 'Conferido',
          name: 'conferred',
          type: 'checkbox',
        })
      }

      return fields;
    }
  },
  watch: {
    currentPage(page) {
      this.startToggler = false;

      this.$store.dispatch('timesheet/loadItems', {
        ...this.filters,
        search: this.search,
        page: page,
        order_by: this.sortBy,
        is_desc: this.sortDesc,
      }).then(() => {
        setTimeout(() => {
          this.startToggler = true;
        }, 500);
      });
    },
    search(newVal) {
      if (newVal.length < 3 && newVal.length != 0) {
        return;
      }

      this.startToggler = false;

      this.$store.dispatch('timesheet/loadItems', {
        ...this.filters,
        search: newVal,
        page: 1,
        order_by: this.sortBy,
        is_desc: this.sortDesc,
      }).then(() => {
        setTimeout(() => {
          this.startToggler = true;
        }, 500);
      });
    },
    sortBy(newVal) {
      this.$store.dispatch('timesheet/loadItems', {
        search: this.search,
        page: this.currentPage,
        order_by: newVal,
        is_desc: this.sortDesc,
      });
    },
    sortDesc(newVal) {
      this.$store.dispatch('timesheet/loadItems', {
        search: this.search,
        page: this.currentPage,
        order_by: this.sortBy,
        is_desc: newVal,
      });
    },
    editingItem: {
      deep: true,
      handler(newVal) {
        if (!newVal.customer_pk) {
          return;
        }

        axios.get('/contract/?customer_pk=' + newVal.customer_pk)
          .then(res => {
            this.contracts = res.data.data.map(c => ({
              pk: c.pk,
              name: c.title,
            }));

            // if (this.contracts.length > 0) {
            //   this.editingItem.contract_pk = this.contracts[0].pk;
            // } else {
            //   this.editingItem.contract_pk = null;
            // }

            this.$forceUpdate();
          });
      }
    },
    filters: {
      deep: true,
      handler(newVal) {
        if (newVal.customer_pk && this.lastFilterLoadedtimesheet != newVal.customer_pk) {
          this.lastFilterLoadedtimesheet = newVal.customer_pk;

          axios.get('/contract/?customer_pk=' + newVal.customer_pk)
            .then(res => {
              this.filtertimesheet = res.data.data.map(c => ({
                pk: c.pk,
                name: c.title,
              }));

              if (this.filtertimesheet.length > 0) {
                this.filters.contract_pk = this.filtertimesheet[0].pk;
              } else {
                this.filters.contract_pk = null;
              }

              this.$forceUpdate();
            });
        }

        this.$store.dispatch('timesheet/loadItems', {
          ...this.filters,
          search: this.search,
          page: this.currentPage,
          order_by: this.sortBy,
          is_desc: this.sortDesc,
        }).then(() => {
          this.startToggler = false;

          setTimeout(() => {
            this.startToggler = true;
          }, 500);
        });
      }
    },
  },
  methods: {
    toggleConferred(item) {
      if (!this.startToggler) {
        return;
      }

      this.$swal.fire({
        title: 'Alterar status',
        text: 'Ao continuar, você irá alterar o status do timesheet. Deseja continuar?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          axios.post('timesheet/' + item.pk + '/toggle-conferred/', {
            conferred: item.conferred = !item.conferred,
            months: result.value
          }).then((response) => {
            setTimeout(() => {
              this.$store.dispatch('timesheet/loadItems', {
              ...this.filters,
              search: '',
              page: this.currentPage,
              order_by: this.sortBy,
              is_desc: this.sortDesc,
            })
              this.$store.dispatch('timesheet/toggleConferred', item.pk)

              if (item.conferred) {
                this.$snotify.success("Timesheet alterado para conferido.", 'Conferido',{
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true
              })
              } else {
                this.$snotify.error("Timesheet alterado para não conferido.", 'Não conferido',{
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true
              })
              }
          }, 500)
          });
        } else {
          window.location.reload();
        }
      });
    },
    openModal() {
      this.isVisible = true;

      this.editingItem.employee_pk = this.$store.state.auth.user.pk;
    },
    clearModal() {
      this.editingItem = {
        timesheet_hours: 0,
        timesheet_minutes: '00',
        area_pk: null,
        timesheet_date: this.today,
      };

      this.contracts = [];

      this.isVisible = false;
    },
    editItem(item) {
      this.isVisible = true;

      const [hours, minutes] = item.timesheet_hours.split(':');

      this.editingItem = {
        ...item,
        timesheet_hours: hours,
        timesheet_minutes: minutes,
      };
    },
    async sendItem() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }

      const json = { ...this.editingItem };

      let minutes = 0;

      switch (json.timesheet_minutes) {
        case '15':
          minutes = 0.25;
          break;
        case '30':
          minutes = 0.50;
          break;
        case '45':
          minutes = 0.75;
          break;
      }

      json.timesheet_hours = Number(json.timesheet_hours) + Number(minutes);
      delete json.timesheet_minutes;

      this.startToggler = false;

      if (!this.editingItem.pk) {
        // Aqui está adicionando, logo no axios seria um post
        this.$store.dispatch('timesheet/addItem', json)
          .then(() => {
            this.$store.dispatch('timesheet/loadItems', {
                ...this.filters,
              })
              .then(() => {
                setTimeout(() => {
                  this.startToggler = true;
                }, 500);
              });

            setTimeout(() => {
              this.startToggler = true;
            }, 500);
          });
      } else {
        // Aqui editando, logo um put
        this.$store.dispatch('timesheet/editItem', json)
          .then(() => {
            setTimeout(() => {
              this.startToggler = true;
            }, 500);
          });
      }

      this.clearModal();
    },
    deleteItem(item) {
      this.$swal.fire({
        title: 'Deletar item',
        text: 'Deseja realmente apagar esse item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('timesheet/deleteItem', item);
        }
      });
    },
    cleanFilter() {
      const date = new Date();

      this.today = date;
      this.filters = {
        customer_pk: null,
        contract_pk: null,
        employee_pk: null,
        contract_type_pk: null,
        area_pk: null,
        // year: date.getFullYear(),
        year: null,
        month: '',
        conferred: null,
        contains_ts_report: null,
        payment_type: null,
      };
    },
    startFilter() {
      const date = new Date();

      this.today = date;
      this.filters = {
        customer_pk: null,
        contract_pk: null,
        employee_pk: null,
        contract_type_pk: null,
        area_pk: null,
        year: date.getFullYear(),
        month: '',
        conferred: false,
        contains_ts_report: null,
        payment_type: null,
      };
    },
    getMinutes(hms) {
      var a = hms.split(':');

      var minutes = (+a[0]) * 60 + (+a[1]);

      if (minutes == 0) {
        return 1;
      }

      return minutes;
    },
  }
}

</script>

<style>
.checkbox-circular {
  /* Tamanho do checkbox */
  width: 20px;
  height: 20px;

  /* Borda circular */
  border-radius: 50%;

  /* Apaga o checkbox padrão */
  appearance: none;
  -webkit-appearance: none;

  /* Posicionamento do cursor */
  cursor: pointer;

  /* Borda */
  border: 2px solid #ccc;

  /* Transição suave */
  transition: 0.2s;
  position: relative;
}

/* Checkbox selecionado */
.checkbox-circular:checked {
  background-color: #42ce0f;
  border-color: #42ce0f;
}

/* Checkbox não selecionado */
.checkbox-circular:not(:checked) {
  background-color: #ff4b4b;;
  border-color: #ff4b4b;
}

/* Insere x no checkbox não selecionado */
.checkbox-circular::before {
  content: "x";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-45%, -50.5%);
  font-size: 14px;
  color: #fff;
}

/* Insere verificado no checkbox selecionado */
.checkbox-circular:checked::before {
  content: "✓";
  font-size: 18px;
  color: #fff;
  transform: translate(-45%, -47%);
}

</style>
